<template>
  <el-form key="username" :model="usernameForm" ref="usernameForm">
    <el-form-item ref="usernameFormItem" prop="mobile">
      <el-input v-model="usernameForm.mobile" clearable autocomplete="on" placeholder="请输入账号/手机号"></el-input>
    </el-form-item>

    <el-form-item prop="password" ref="passFormItem">
      <el-input v-model="usernameForm.password" type="password" clearable show-password placeholder="请输入密码"></el-input>
    </el-form-item>

    <!--<div class="password-login-tip"><a href="/forget">忘记密码？</a></div>-->

    <el-form-item class="login__button">
      <ghidri-button type="primary" size="large" :loading="loading" @click="loginByPass" @keydown.enter.native="loginByPass">登 录</ghidri-button>
    </el-form-item>
  </el-form>
</template>
<script>
  import util from "@/util/util";

  import store from "@/store/index.js";

  export default {
    name: "UsernameLogin",
    data() {
      return {
        usernameForm: {
          mobile: "",
          password: ""
        },
        loading: false,

        redirect: undefined
      };
    },
    watch: {
      $route: {
        handler: function(route) {
          this.redirect = route.query && route.query.redirect;
        },
        immediate: true
      }
    },
    methods: {
      async loginByPass() {
        const _this = this;
        let mobile = _this.usernameForm.mobile;
        let password = _this.usernameForm.password;
        if (!util.verifyMobile(mobile)) {
          _this.$message.warning("手机号不正确");
          return;
        }

        if (!password) {
          _this.$message.warning("请输入密码");
          return;
        }
        _this.loading = true;

        let key = await util.getRandomStr(mobile);
        password = util.encryption(password, key);//加密
        const loginForm = {
          mobile, password
        };
        store.dispatch("user/loginByPassword", loginForm).then(() => {
          _this.$router.push({ path: _this.redirect || "/" });
        }).catch((err) => {
          _this.loading = false;
          _this.$message.error(err || "网络出错，请稍后再试");
        });

      }

    }
  };
</script>

<style scoped lang="less">

  .password-login-tip {
    line-height: 22px;
    margin-top: -24px;
    text-align: right;
    padding-right: 5px;
    margin-bottom: 40px;
  }

  .password-login-tip a {
    color: #3370ff;
    font-size: 14px;
  }
</style>
